<template>
	<div id="social">	
		<h1 class="intro mb">Social:</h1>
		<div class="big-text">
			<a href="http://www.instagram.com/thearmedixi" target="_blank">INSTA</a> / <a href="https://www.facebook.com/thearmed" target="_blank">FACEBOOK</a> / <a href="https://www.youtube.com/channel/UCVg1SNLWMLWFVKXw2BOTKZA" target="_blank">YOUTUBE</a> / <a href="https://twitter.com/thearmed" target="_blank">TWITTER</a>
		</div>	
	</div>
</template>

<script>
export default {
  name: 'Social',
  mounted: function() {
	  this.$parent.close_mobile();
  }
}
</script>